document.addEventListener('DOMContentLoaded', () => {

    // Mobil menu
    document.querySelector('.open-menu').addEventListener('click', function(e) {
        e.preventDefault();

        document.querySelector('nav').classList.toggle('show');
    });

    // Cart - Shipping radio
    const shippingSelectors = document.querySelectorAll('.shipping-selector')
    for (const shippingSelector of shippingSelectors) {
        shippingSelector.addEventListener('click', function(event) {
            shippingSelectors.forEach( function (e) {
                if (e.getElementsByTagName('input')[0].checked) {
                    e.classList.add('selected');
                } else {
                    e.classList.remove('selected');
                }
            });
        })
    }

    // Cart - Payment radio
    const paymentSelectors = document.querySelectorAll('.payment-selector')
    for (const paymentSelector of paymentSelectors) {
        paymentSelector.addEventListener('click', function(event) {
            paymentSelectors.forEach( function (e) {
                if (e.getElementsByTagName('input')[0].checked) {
                    e.classList.add('selected');
                } else {
                    e.classList.remove('selected');
                }
            });
        })
    }
    // Tooltips
    $('[data-toggle="tooltip"]').tooltip()
});
